var map = {
	"./BActions.json": "ccd1",
	"./BFactory.json": "f0e2",
	"./BPool.json": "f703",
	"./CRPFactory.json": "5ce6",
	"./ConfigurableRightsPool.json": "2401",
	"./DSProxy.json": "68ad",
	"./DSProxyRegistry.json": "318e",
	"./ExchangeProxy.json": "6ba0",
	"./ExchangeProxyCallable.json": "ebe9",
	"./Multicall.json": "29eb",
	"./TestToken.json": "8d51",
	"./Vault.json": "d4d8",
	"./WeightedPool.json": "e695",
	"./Weth.json": "53bd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "be09";